import { render, staticRenderFns } from "./InviraUserForm.vue?vue&type=template&id=7d0b884c&scoped=true"
import script from "./InviraUserForm.vue?vue&type=script&lang=js"
export * from "./InviraUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0b884c",
  null
  
)

export default component.exports